import { Box, Grid, Card, styled } from "@mui/material";
import { H3, Small } from "../components/Typography";
import { FC } from "react";

// styled components
const StyledCard = styled(Card)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-around",
  alignItems: "center",
  padding: "1rem 3rem",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column-reverse",
    padding: "2rem",
    "& img": { marginBottom: "1.5rem" },
  },
  backgroundColor: "#FBF6E4",
  marginX: 5,
  marginY: 5,
}));

// component props interface
interface GradientCardProps {
  image: string;
  heading: string;
  subheading: string;
  bgColor: string;
  onPress: any;
}

const GradientCard: FC<GradientCardProps> = ({
  image,
  heading,
  subheading,
  bgColor,
  onPress,
}) => {
  return (
    <Grid
      xs={15.8}
      md={3.8}
      sx={{
        background: bgColor,
        p: 2,
        borderRadius: 2,
        width: {
          md: "24%",
          xs: "95%",
        },
        mt: {
          md: 0,
          xs: 2,
          sm: 1,
        },
      }}
    >
      <div onClick={onPress}>
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            flexDirection: "row",
            mb: 0.5,
          }}
        >
          <Box
            sx={{
              background: "#fff",
              borderRadius: "50%",
              mr: 1,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              component="img"
              sx={{
                height: {
                  xs: 30,
                  sm: 30,
                  md: 30,
                },
                minwidth: {
                  xs: 30,
                  sm: 30,
                  md: 30,
                },
                m: 0.6,
                mb: 0,
                p: 1.1,
              }}
              src={image}
              alt="saas"
            />
          </Box>
          <H3
          fontWeight={500}
          fontSize={16}
            color="#F6F6F6"
            sx={{
              fontFamily: "'Poppins', sans-serif",
            }}
          >
            {heading}
          </H3>
        </Box>
        <Small
          sx={{
            fontWeight: "400",
            fontFamily: "'Poppins', sans-serif",
          }}
          color="#F6F6F6"
        >
          {subheading}
        </Small>
      </div>
    </Grid>
  );
};

export default GradientCard;
